import { cn } from '@heidi/utils';
import { FormattedMessage, useIntl } from 'react-intl';

import type { ApprovalResponse } from '../../../../contracts';
import { approvalHistoryMessages } from './approval-history.messages';

export interface ApprovalHistoryProps {
  approval: ApprovalResponse;
}

export const ApprovalHistory = ({ approval }: ApprovalHistoryProps) => {
  const intl = useIntl();

  if (approval.status === 'pending') return null;

  const modifiedDiffers =
    approval.modified_input !== null &&
    JSON.stringify(approval.modified_input) !== JSON.stringify(approval.tool_input);

  return (
    <div
      className={cn(
        'rounded-lg border p-3 text-xs',
        approval.status === 'approved'
          ? 'border-border bg-surface-container'
          : 'border-validation-destructive-border bg-validation-destructive-muted/40'
      )}
    >
      <div className="flex flex-wrap items-center gap-2 text-text-secondary">
        {approval.resolved_by ? (
          <FormattedMessage
            {...approvalHistoryMessages.resolvedBy}
            values={{
              status: approval.status,
              name: approval.resolved_by,
              statusStyle: (chunks) => (
                <span className="font-medium text-text-primary">{chunks}</span>
              ),
              resolver: (chunks) => <span>{chunks}</span>,
            }}
          />
        ) : (
          <span className="font-medium text-text-primary">
            <FormattedMessage
              {...approvalHistoryMessages.status}
              values={{ status: approval.status }}
            />
          </span>
        )}
        {approval.resolved_at && (
          <span>
            {intl.formatDate(new Date(approval.resolved_at), {
              dateStyle: 'short',
              timeStyle: 'short',
            })}
          </span>
        )}
      </div>
      {approval.reason && (
        <div className="mt-2 text-text-secondary">{approval.reason}</div>
      )}
      {modifiedDiffers && (
        <pre className="mt-2 overflow-auto rounded-md bg-surface p-2 text-text-primary">
          {JSON.stringify(approval.modified_input, null, 2)}
        </pre>
      )}
    </div>
  );
};
